import React from 'react';

const ErrorPage = () => {
    return (
        <div
            className="d-flex justify-content-center align-items-center"
            style={{height: '550px'}}
        >
            <div className="text-center">
                <h2>404</h2>
                <h3>Page Not Found!!!</h3>
            </div>
        </div>
    );
};

export default ErrorPage;